// @flow
export const RECEIVE_INDEX: string = 'RECEIVE_INDEX';
export const SET_API: string = 'SET_API';
export const SET_GUIDE: string = 'SET_GUIDE';
export const SET_VERSION: string = 'SET_VERSION';



// WEBPACK FOOTER //
// ./src/reducers/version/constants.js